import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy Norwegian route — permanent redirect to the German path
export const Route = createFileRoute("/artikler/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/ratgeber/$slug", params, statusCode: 301 });
  },
});
